import React, { ReactElement } from 'react';

interface IconProps {
  color?: string;
}

const PrivacyBlockedIcon = ({ color = '#E2C92D' }: IconProps): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none">
      <mask
        id="a"
        width={26}
        height={26}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h26v26H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill={color}
          d="M13 24.06c-2.573-.644-4.698-2.112-6.373-4.403-1.676-2.291-2.514-4.835-2.514-7.633v-6.76L13 1.94l8.887 3.325v6.76c0 2.798-.838 5.342-2.513 7.633-1.676 2.29-3.8 3.759-6.374 4.402Zm0-2.573c1.721-.568 3.163-1.638 4.326-3.21A10.516 10.516 0 0 0 19.368 13H13v-8.44L6.578 6.967v5.545c0 .135.018.297.053.487h6.37v8.488Z"
        />
      </g>
    </svg>
  );
};

export default PrivacyBlockedIcon;
